import React, {useCallback, useEffect, useState} from "react";

import {useHasInternalAccess} from "components/common/hooks/useHasInternalAccess";

import GuybrushDialog from "./GuybrushDialog";
import {buildElementContext, ElementContext} from "./elementContext";

// App-level wrapper that listens for Ctrl+Alt+Right-click anywhere in the UI,
// captures the target element's context, and opens the Guybrush dialog.
// Mounted in App.tsx so it works on every page, not just the editor.
// Renders nothing for users without internal access.
function GlobalGuybrush() {
    const hasInternalAccess = useHasInternalAccess();
    const [open, setOpen] = useState(false);
    const [elementContext, setElementContext] = useState<ElementContext | undefined>(undefined);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    useEffect(() => {
        if (!hasInternalAccess) return;

        const handleContextMenu = (event: MouseEvent) => {
            if (!event.ctrlKey || !event.altKey) return;

            event.preventDefault();
            const target = event.target;
            if (target instanceof HTMLElement) {
                setElementContext(buildElementContext(target));
            } else {
                setElementContext(undefined);
            }
            setOpen(true);
        };

        window.addEventListener("contextmenu", handleContextMenu);
        return () => {
            window.removeEventListener("contextmenu", handleContextMenu);
        };
    }, [hasInternalAccess]);

    if (!hasInternalAccess) {
        return null;
    }

    return <GuybrushDialog open={open} onClose={handleClose} elementContext={elementContext} />;
}

export default React.memo(GlobalGuybrush);
